import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'fuse-progress-bar',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div class="fuse-progress-bar" *ngIf="visible">
      <div class="fuse-progress-bar-content">
        <div class="fuse-progress-bar-indeterminate"></div>
      </div>
    </div>
  `,
    styles: [`
    .fuse-progress-bar {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 9999;
      height: 3px;
      background: rgba(0, 0, 0, 0.1);
    }
    
    .fuse-progress-bar-content {
      height: 100%;
      background: #1976d2;
      animation: progress 1s ease-in-out infinite;
    }
    
    @keyframes progress {
      0% { width: 0%; }
      100% { width: 100%; }
    }
  `]
})
export class FuseProgressBarComponent {
    @Input() visible = false;
}